export const PARAMS = {
	duration: 800, // ms — draw time per span
	delay: 400, // ms — pause before first span starts
	cascadeOffset: 10, // ms — gap between spans (cascade-in effect)
	strokeWidth: 0.4, // → Math.max(20 × 0.4, 6) = 8px effective stroke
	strokeCount: 5, // base strokes per ~20px line height
	wiggle: 1, // bezier control-point Y variance (px)
	spread: 0.7, // 70% of span height used by stroke stack
	jitter: 3, // random per-stroke Y offset (px)
};
